import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { UrlApi } from "../../../../../services/apirest";
import InputMask from "react-input-mask";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Notify from "../../../../Notify";
import Alerta from "../../../../Alerta";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import AddBoxIcon from "@mui/icons-material/AddBox";
import AddBateria from "./AddBateria";

function DialogRetirarTanque(props) {
  const [sucursales, setSucursales] = useState([{}]);
  const [dataMovimiento, setDataMovimiento] = useState({
    id_tanque: props.tanque.id_tanque,
    usuario:localStorage.getItem("user"),
    id_sucursal: "",
    nro_remito: "",
    fecha_remito: "",
    id_direccionentrega: "",
    id_bateria: "",
  });
  const [destino, setDestino] = useState("");
  const [direcciones, setDirecciones] = useState(props.direcciones);
  const [baterias, setBaterias] = useState([]);
  const [altaBateria, setAltaBateria] = useState(false);
  const [ultimaBateria, setearUltimaBateria] = useState(false);
  const [disBtnGuardar, setDisBtnGuardar] = useState(false);

  const obtenerSucursales = () => {
    fetch(UrlApi + "/sucursales")
      .then((data) => data.json())
      .then((data) => setSucursales(data));
  };

  const obtenerBaterias = (direccion) => {
    fetch(UrlApi + "/baterias2/dir/" + (direccion || dataMovimiento.id_direccionentrega))
      .then((data) => data.json())
      .then((data) => setBaterias(data));
  };

  useEffect(() => {
    obtenerSucursales();
  }, []);


  const almacenarDataMovimiento = (e) => {
    setDataMovimiento({
      ...dataMovimiento,
      [e.target.name]: e.target.value === " " ? null : e.target.value,
    });
  };

  useEffect(()=>{
    if(baterias.length>0){
    if(ultimaBateria){
      setDataMovimiento({
        ...dataMovimiento,
        id_bateria: baterias[0]?.idbateria,
      })
      setearUltimaBateria(false)
      }
    }
  },[baterias])

  const [notificacion, setNotificacion] = useState(false);

  //Nueva funcion de guardado. El resto de la funcionalidad se pasó al backend y se resuelve con una transacción.
  async function guardar (e){
    setDisBtnGuardar(true); 
    e.preventDefault(e);
    const response = await fetch(
      `${UrlApi}/tanques_contratos/retirar/${props.tanque.id_tanquecontrato}/${destino}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body:JSON.stringify({dataMovimiento})
          }
        );    
    if(response.ok){
      setNotificacion({
        open:true,
        color:"#D4EFDF",
        severity:"success",
        mensaje:"Movimiento guardado",
      })
      props.actualizar()
    } else{
      alert("Error guardando movimiento.")
    }
  }

  const borrarSel = () => {
    setDataMovimiento({ ...dataMovimiento, id_bateria: null });
    obtenerBaterias();
  };

  const handleClose = () => {
    props.setOpen(false);
  };


  return (
    <div>
      <Dialog
        open={props.open}
        onClose={() => props.setOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        {
          notificacion.open && (
            <Notify
              open={notificacion.open}
              color={notificacion.color}
              severity={notificacion.severity}
              mensaje={notificacion.mensaje}
              handleClose={handleClose}
            />
          )
        }
        <Box backgroundColor={"#1F618D"}>
          <DialogTitle>
            <div>
              <Typography variant="h6" color="#ffffff">
                Cambio De Ubicación
              </Typography>
            </div>
          </DialogTitle>
        </Box>
        <DialogContent>
          <DialogContentText>
            Usted está a punto de desvincular el tanque{" "}
            <b>
              {" "}
              <u>N° Serie</u>: {props.tanque.nro_serie}{" "}
            </b>{" "}
            del{" "}
            <b>
              <u>domicilio:</u> {props.direccion.direccion_entrega}
            </b>
            . A continuación, indique el destino del tanque:
          </DialogContentText>
          <Grid
            container
            spacing={1}
            direction="row"
            justifyContent="center"
            p={3}
          >
            <Grid item xs={3}>
              <FormControl fullWidth focused required>
                <InputLabel>Destino</InputLabel>
                <Select
                  value={destino}
                  label="Destino"
                  onChange={(e) => {
                    setDestino(e.target.value)
                    setDataMovimiento({
                      ...dataMovimiento,
                      id_sucursal: "",
                      nro_remito: "",
                      fecha_remito: "",
                      id_direccionentrega: "",
                      id_bateria: "",
                    })
                    if(e.target.value===1){
                      setBaterias([])
                    }
                  }}
                >
                  <MenuItem value={1}>Sucursal</MenuItem>
                  <MenuItem value={2}>Otro Domicilio De Entrega</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {destino && destino === 1 ? (
              <>
                <Grid item xs={4}>
                  <FormControl fullWidth focused required>
                    <InputLabel>Sucursal</InputLabel>
                    <Select
                      name="id_sucursal"
                      value={dataMovimiento.id_sucursal}
                      label="Sucursal"
                      onChange={almacenarDataMovimiento}
                    >
                      {sucursales ? (
                        sucursales.map((elemento) => (
                          <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.nombre}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem>Sucursales No Disponibles</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2.5}>
                  <InputMask
                    mask="99999-99999999"
                    value={dataMovimiento.nro_remito}
                    disabled={false}
                    maskChar=" "
                    onChange={almacenarDataMovimiento}
                  >
                    {() => (
                      <TextField
                        autoFocus
                        fullWidth
                        focused
                        name="nro_remito"
                        label="Nro Remito"
                      />
                    )}
                  </InputMask>
                </Grid>
                <Grid item xs={2.5}>
                  <TextField
                    fullWidth
                    type="date"
                    color="primary"
                    focused
                    value={dataMovimiento.fecha_remito}
                    label="Fecha Remito"
                    name="fecha_remito"
                    variant="outlined"
                    onChange={almacenarDataMovimiento}
                  />
                </Grid>
              </>
            ) : null}
            {destino === 2 ? (
              <>
                <Grid item xs={4}>
                  <FormControl fullWidth focused required>
                    <InputLabel>Direccion De Entrega</InputLabel>
                    <Select
                      name="id_direccionentrega"
                      value={dataMovimiento.id_direccionentrega}
                      label="Dirección De Entrega"
                      onChange={(e)=>{
                        // console.log(e.target.value)
                        almacenarDataMovimiento(e)
                        obtenerBaterias(e.target.value)
                      }}
                    >
                      {direcciones ? (
                        direcciones.map((elemento) => (
                          <MenuItem
                            key={elemento.id}
                            value={elemento.id}
                            disabled={props.direccion.id === elemento.id}
                          >
                            {elemento.direccion_entrega} (
                            {elemento.nombre_direccion})
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem>Direcciones No Disponibles</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <FormControl
                    fullWidth
                    focused
                    disabled={dataMovimiento.id_direccionentrega === ""}
                  >
                    <InputLabel>Batería</InputLabel>
                    <Select
                      name="id_bateria"
                      value={dataMovimiento.id_bateria}
                      label="Batería"
                      onChange={almacenarDataMovimiento}
                    >
                      {baterias !== "" && baterias.length > 0
                        ? baterias.map((elemento) => (
                            <MenuItem
                              key={elemento.idbateria}
                              value={elemento.idbateria}
                            >
                              {elemento.nro} ({elemento.nombre})
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={1}>
                  <Tooltip title="Borrar Selección">
                    <span>
                      <IconButton
                        disabled={!baterias}
                        color="primary"
                        size="large"
                        onClick={() => borrarSel()}
                      >
                        <DeleteIcon fontSize="inherit" />
                      </IconButton>
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1}>
                  <Tooltip title="Nueva Bateria">
                    <span>
                      <IconButton
                        disabled={!dataMovimiento.id_direccionentrega}
                        color="primary"
                        size="large"
                        onClick={(e) => setAltaBateria(true)}
                      >
                        <AddBoxIcon fontSize="inherit" />
                      </IconButton>
                    </span>
                  </Tooltip>
                </Grid>
              </>
            ) : null}
          </Grid>
          <Grid
            container
            spacing={1}
            direction="row"
            justifyContent="center"
          ></Grid>
        </DialogContent>
        <DialogActions>
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Grid item>
              <Button variant="outlined" color="error" onClick={handleClose}>
                Cancelar
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="success"
                onClick={(e) => guardar(e)}
                disabled={
                  disBtnGuardar ||
                  !destino ||
                  (destino === 1 && !dataMovimiento.id_sucursal) ||
                  (destino === 2 && !dataMovimiento.id_direccionentrega)
                }
              >
                Confirmar
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      {altaBateria ? (
        <>
          <AddBateria
            open={altaBateria}
            setOpen={setAltaBateria}
            datos={dataMovimiento.id_direccionentrega} //el id de la direccion donde ira la bateria
            cliente={props.cliente} //para tomar el sisven_id
            actualizar={()=>obtenerBaterias()}
            setearUltimaBateria={setearUltimaBateria}
          />
        </>
      ) : null}
    </div>
  );
}

export default DialogRetirarTanque;
